import type { User } from "oidc-client-ts";
import type { UserManagerSettings } from "oidc-client-ts";

export function getCognitoAuthConfig(): UserManagerSettings {
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID?.trim();
  const region = process.env.REACT_APP_COGNITO_REGION?.trim();
  const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID?.trim();

  const authority =
    (region && userPoolId
      ? `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`
      : null);

  if (!clientId || !authority) {
    throw new Error(
      "missing authority or client id"
    );
  }

  const origin = window.location.origin;

  return {
    authority,
    client_id: clientId,
    redirect_uri: origin,
    post_logout_redirect_uri: origin,
    response_type: "code",
    scope: "openid",
    automaticSilentRenew: true,
  };
}

export function onSigninCallback(_user: User | undefined): void {
  window.history.replaceState({}, document.title, window.location.pathname);
}
